import {HttpRequest} from '../../../util/http';

export const flipNotifyUser = (userId: number, notifyStatus: boolean) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
      update_notify: notifyStatus ? 1 : 0
    }
    const method = 'POST'
    let success = false;
    HttpRequest.fetch<any>("scripts/users/update_notify", {data, method}).then((res) => {
      if (res.message === "success") success = true;
      resolve(success)
    });
  });
};

export const checkForAssignedActionAlerts = (userId: number) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
    }
    const method = 'POST'
    HttpRequest.fetch<any>("scripts/users/hasAssignedAlerts", {data, method}).then((count: number) => {
      resolve(count)
    });
  });
};

export const changeActiveStatus = (userId: number) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
      active: 0,
    }
    const method = 'POST'
    let success = false;
    HttpRequest.fetch<any>("scripts/user_delete", {data, method}).then((res) => {
      if (res.message === "success") success = true;
      resolve(success)
    });
  });
};

export const updatePassword = (userId: number, password: string) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
      password: password,
    }
    const method = 'POST'
    let success = false;
    HttpRequest.fetch<any>("scripts/users/update_password", {data, method}).then((res) => {
      if (res.message === "success") success = true;
      resolve(success)
    });
  });
}

export const getActionAlertInfo = () => {
  return new Promise((resolve, reject) => {
    const data = {}
    const method = 'POST'
    HttpRequest.fetch<any>("/scripts/action_alerts_reports/get_dashboard_count_per_project", {data, method}).then((res) => {
      resolve(res)
    });
  });
}
